import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PER_ActiveEmployees = _resolveComponent("PER_ActiveEmployees")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_ValoriParametriiSalarizare = _resolveComponent("ValoriParametriiSalarizare")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, { cols: "6" }, {
        default: _withCtx(() => [
          _createVNode(_component_PER_ActiveEmployees, { onSelectionChanged: $options.handleSelectionChanged }, null, 8, ["onSelectionChanged"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, { cols: "6" }, {
        default: _withCtx(() => [
          _createVNode(_component_ValoriParametriiSalarizare, {
            empId: $data.selectedEmpId,
            mode: $data.selectedMode
          }, null, 8, ["empId", "mode"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}